import classNames from 'classnames';
import Avatar from '@mui/material/Avatar';
import './ProfileImage.css';

export type ImageSize = 'large' | 'xl';

const ProfileImage = ({ image_url, size }: { image_url: string; size?: ImageSize }) => {
  const avatarSize = size === 'xl' ? 120 : 60;

  return (
    <div className="profileImageContainer">
      <Avatar
        alt="profile"
        src={image_url}
        sx={{ width: avatarSize, height: avatarSize }}
        className={classNames({
          ['profileImage']: size === 'large',
          ['profileImageXl']: size === 'xl'
        })}
      />
    </div>
  );
};

export default ProfileImage;
